import { refs, domReady, booleanDataset, hasBooleanDataset, dispatchEvent } from '../modules/utils.js';

class MobileMenu extends HTMLElement {
  static get observedAttributes() {
    return ['data-display'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-display') {
      const display = newValue === '';
      booleanDataset(document.documentElement, 'unscrollable', display);
      dispatchEvent('mobilemenu:display', { value: display });
    }
  }

  async connectedCallback() {
    await domReady();
    this.refs = refs(this);
    this.#listeners();
  }

  #listeners() {
    document.addEventListener('navbar:mobilemenu', () => {
      booleanDataset(this, 'display', !hasBooleanDataset(this, 'display'));
    });

    this.addEventListener('click', (e) => {
      if (e.target === this) {
        booleanDataset(this, 'display', false);
      }
    });
  }
}

customElements.define('mobile-menu', MobileMenu);
